<div class="report-filter-details-dialog">

    <div class="dialog-layout">

        <h2 class="dialog-h2">
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.report-filter-details-dialog.title"></sc-dictionary-label>
        </h2>


        <div class="top-info"></div>

        <div class="dialog-content" [formGroup]="filterDetailsFormGroup">

            <div class="report-timeframe">
                <h3>
                  <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.report-filter-details-dialog.timeframe"></sc-dictionary-label>
                </h3>
                <div class="timeframe-selection">
                    <div class="timeframe-selection-layout">
                        <div class="timeframe-selection-options">
                            <mat-chip-list #chipList formControlName="timeframeType" name="timeframeType" selectable>
                                <mat-chip *ngFor="let o of reportFilterTimeframeTypeOptions" [highlighted]="true"
                                    [removable]="false" [value]="o" (click)="onFilterTypeClicked(o)">
                                    <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.report-filter.timeframe-type-option.{{o}}"></sc-dictionary-label>
                                </mat-chip>
                            </mat-chip-list>
                        </div>
                        <div class="timeframe-selection-datepicker">
                            <div class="timeframe-selection-datepicker-layout">
                                <mat-form-field class="day-field" *ngIf="dayVisible" appearance="fill">
                                  <mat-label>
                                    <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.report-filter-details-dialog.day"></sc-dictionary-label>
                                  </mat-label>
                                    <input matInput matInputInteger name="day" formControlName="day" required>
                                </mat-form-field>
                                <mat-form-field class="month-field" *ngIf="monthVisible" appearance="fill">
                                  <mat-label>
                                    <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.report-filter-details-dialog.month"></sc-dictionary-label>
                                  </mat-label>
                                    <mat-select name="month" formControlName="month" required>
                                        <mat-option [value]="1">
                                          <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.report-filter-details-dialog.month.january"></sc-dictionary-label>
                                        </mat-option>
                                        <mat-option [value]="2">
                                          <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.report-filter-details-dialog.month.february"></sc-dictionary-label>
                                        </mat-option>
                                        <mat-option [value]="3">
                                          <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.report-filter-details-dialog.month.march"></sc-dictionary-label>
                                        </mat-option>
                                        <mat-option [value]="4">
                                          <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.report-filter-details-dialog.month.april"></sc-dictionary-label>
                                        </mat-option>
                                        <mat-option [value]="5">
                                          <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.report-filter-details-dialog.month.may"></sc-dictionary-label>
                                        </mat-option>
                                        <mat-option [value]="6">
                                          <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.report-filter-details-dialog.month.june"></sc-dictionary-label>
                                        </mat-option>
                                        <mat-option [value]="7">
                                          <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.report-filter-details-dialog.month.july"></sc-dictionary-label>
                                        </mat-option>
                                        <mat-option [value]="8">
                                          <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.report-filter-details-dialog.month.august"></sc-dictionary-label>
                                        </mat-option>
                                        <mat-option [value]="9">
                                          <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.report-filter-details-dialog.month.september"></sc-dictionary-label>
                                        </mat-option>
                                        <mat-option [value]="10">
                                          <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.report-filter-details-dialog.month.october"></sc-dictionary-label>
                                        </mat-option>
                                        <mat-option [value]="11">
                                          <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.report-filter-details-dialog.month.november"></sc-dictionary-label>
                                        </mat-option>
                                        <mat-option [value]="12">
                                          <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.report-filter-details-dialog.month.december"></sc-dictionary-label>
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field class="year-field" *ngIf="yearVisible" required appearance="fill">
                                  <mat-label>
                                    <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.report-filter-details-dialog.year"></sc-dictionary-label>
                                  </mat-label>
                                    <input matInput matInputInteger name="year" formControlName="year">
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="filter-selection">
                <h3>
                  <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.report-filter-details-dialog.filter"></sc-dictionary-label>
                </h3>

                <mat-radio-group class="type-selection" formControlName="filterType" name="filterType">

                    <mat-radio-button [value]="reportFilterType.none">
                      <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.report-filter-details-dialog.filter-type.no-filter"></sc-dictionary-label>
                    </mat-radio-button>

                    <mat-radio-button [value]="reportFilterType.options">
                      <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.options"></sc-dictionary-label>
                    </mat-radio-button>

                    <ng-container *ngIf="optionsFilterVisible">
                        <div class="transport-options">
                            <div class="form-box" *ngIf="optionsFilterVisible">
                                <div class="sections">
                                    <div class="section" *ngFor="let column of columns">
                                        <div class="options" *ngFor="let to of column.transportOptions">
                                            <mat-checkbox class="options-checkbox"
                                                [formControlName]="OPTIONS_FORM_PREFIX + to.id"
                                                name="{{OPTIONS_FORM_PREFIX + to.id}}">
                                                <sc-dictionary-label [dictionaryKey]="to.nameDictionaryKey"></sc-dictionary-label>
                                            </mat-checkbox>

                                            <div class="child-options" *ngIf="this.filterModel.transportOptionIds.has(to.id)">
                                                <div *ngFor="let childOption of to.transportOptions">
                                                    <mat-checkbox class="options-checkbox"
                                                        [formControlName]="OPTIONS_FORM_PREFIX + childOption.id"
                                                        name="{{OPTIONS_FORM_PREFIX + childOption.id}}">
                                                        <sc-dictionary-label [dictionaryKey]="childOption.nameDictionaryKey"></sc-dictionary-label>
                                                    </mat-checkbox>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <mat-radio-button [value]="reportFilterType.structure">
                      <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.report-filter-details-dialog.filter-type.structure"></sc-dictionary-label>
                    </mat-radio-button>
                    <div [hidden]="!structureFilterVisible">
                        <app-structure-node-selection (selectedStructureChanged)="onSelectedStructureChanged($event)"
                            [selectedNode]="selectedStructureNode"></app-structure-node-selection>
                    </div>
                </mat-radio-group>
            </div>
        </div>


        <div class="messages">

        </div>
        <div class="dialog-toolbar">
            <div class="left">
            </div>
            <div class="center">
            </div>
            <div class="right">
                <button class="cancel-button" mat-button (click)="cancelDialog()">
                  <sc-dictionary-label dictionaryKey="tmc-yard.common.action.cancel"></sc-dictionary-label>
                </button>
                <button class="confirm-button" mat-button (click)="confirmFilter()">
                  <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.report-filter-details-dialog.action.confirm"></sc-dictionary-label>
                </button>
            </div>
        </div>
    </div>
